import httpClient from "./httpClient";

/**
 * Obtém os logs de integração (sucesso, erros, etc.) de forma paginada e filtrada.
 * @param {object} params - Parâmetros como { page, size, status, origem, q }
 */
export async function listarLogsJoin(params) {
  const response = await httpClient.get("/api/integracao/join/logs", { params });
  return response.data;
}

/**
 * Dispara a varredura de producao usada pelo churn (56 dias, ~5 min) ou a passada rapida.
 * Roda em segundo plano: o acompanhamento e pelo historico de execucoes.
 */
export async function dispararVarreduraProducao({ rapida = false } = {}) {
  const response = await httpClient.post("/api/integracao/join/varredura-producao", null, {
    params: { rapida },
  });
  return response.data;
}

export async function sincronizarJoinManual() {
  const response = await httpClient.post("/api/integracao/join/sync");
  return response.data;
}

/**
 * Verifica se a sincronização em segundo plano está ativa/rodando.
 * @returns {Promise<object>} Objeto contendo { running: boolean }
 */
export async function obterStatusJoin() {
  const response = await httpClient.get("/api/integracao/join/status");
  return response.data;
}

/**
 * Obtém os logs de uma execução específica de forma paginada e filtrada.
 * @param {number|string} execucaoId - ID da execução
 * @param {object} params - Parâmetros como { page, size, status, q }
 */
export async function listarLogsDaExecucaoJoin(execucaoId, params) {
  const response = await httpClient.get(`/api/integracao/join/executions/${execucaoId}/logs`, { params });
  return response.data;
}

/**
 * Busca geral por parceiro em todos os eventos da integração (webhook e API), com o payload recebido.
 * @param {object} params - { q: código Join, CPF/CNPJ ou nome; status?: "ERROR" | "WARNING" | "SUCCESS"; page, size }
 */
export async function buscarLogsPorParceiroJoin(params) {
  const response = await httpClient.get("/api/integracao/join/logs/busca", { params });
  return response.data;
}
